import React, { useState } from "react";
import { useAppSelector } from "../../../context-store";
import { PageModeEnum } from "../../../models/enums/PageModeEnum";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TableContainer from "@mui/material/TableContainer";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableHead from "@mui/material/TableHead";
import DomainModel from "../../../models/company/domain/response/DomainModel";
import DomainRequestModel from "../../../models/company/domain/request/DomainRequestModel";

interface DomainGridProps {
    domainList: DomainModel[];
    totalSize: number;
    currentPage: number;
    pagesize: number;
    sortColumn: string;
    sortDirection: "asc" | "desc";
    pageSizesList: number[];
    domainNameFilterValue: string;
    onDomainAction: (row: DomainRequestModel, actionType: string) => void;
    onPageChangeAction: (newPage: number) => void;
    onPageSizeChangeAction: (newPageSize: number) => void;
    onSortAction: (newSortColumn: string, sortDir: string) => void;
    onFilterAction: (filterColumn: string, filterValue: string) => void;
}

const DomainGridComponent = (props: DomainGridProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [domainNameFilter, setDomainNameFilter] = useState<string>(props.domainNameFilterValue);
    const ActionFormatter = (
        cell: any,
        row: DomainModel,
        rowIndex: number
    ) => {
        return (
            <div className="text-center-align">
                <a onClick={() => { editDomain(row); }}>Edit</a>
            </div>
        );
    };

    const editDomain = (row: DomainModel) => {
        if (loggedInUser !== null) {
            let domainRequestModel: DomainRequestModel = {
                domainId: row.domainId,
                domainName: row.domainName,
                description: row.description,
                companyId: loggedInUser?.profileId,
                userId: loggedInUser?.userId
            }
            props.onDomainAction(domainRequestModel, PageModeEnum.Edit);
        }
    };

    const columnsDomains = [
        { Key: "DomainName", text: "Domain Name", sort: true, searchable: true },
        { Key: "Description", text: "Description", sort: false, searchable: false },
        { Key: "Actions", text: "Actions", sort: false, searchable: false, formatter: ActionFormatter }
    ];

    const createSortHandler = (property: string) => (event: React.MouseEvent) => {
        props.onSortAction(property, props.sortDirection === "asc" ? "desc" : "asc")
    };

    const handleChangePage = (event: any, newPage: number) => {
        props.onPageChangeAction(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        props.onPageSizeChangeAction(parseInt(event.target.value, 10));
    };

    const filterOnChange = (key: string, value: string) => {
        setDomainNameFilter(value);
        if ((value && value.length > 2) || value === "") {
            props.onFilterAction(key, value);
        }
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columnsDomains.map((column: any) => (
                                    <TableCell key={column.key} className="table-header-cell">
                                        {column.sort &&
                                            <TableSortLabel
                                                active={props.sortColumn === column.key}
                                                direction={props.sortColumn === column.key ? props.sortDirection : "asc"}
                                                onClick={createSortHandler(column.key)}>
                                                {column.text}
                                            </TableSortLabel>
                                        }
                                        {column.searchable &&
                                            <input type="text" placeholder="search" className="mat-header-filter-input" value={domainNameFilter}
                                                onClick={(e) => e.stopPropagation()} onChange={(e) => filterOnChange(column.key, e.target.value)}></input>
                                        }
                                        {!column.sort &&
                                            <span>{column.text}</span>
                                        }
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.domainList.map((domain: DomainModel, index) => (
                                <TableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? 'white' : '#f5f5f5' }}>
                                    <TableCell>{domain.domainName}</TableCell>
                                    <TableCell>{domain.description}</TableCell>
                                    <TableCell>
                                        <a onClick={() => { editDomain(domain); }} title="Edit Domain">
                                            <i className="fa fa-edit grid-icon blue"></i>
                                        </a>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={props.pageSizesList}
                    component="div"
                    count={props.totalSize}
                    rowsPerPage={props.pagesize}
                    page={props.currentPage - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </div>
    );
};
export default DomainGridComponent;